import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles/globals.css';
import './styles/dashboard.css';
import './styles/legal.css';

const rootEl = document.getElementById('root');
createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
